const latestArticle = {
  "status": "true",
  "message": "取得最新文章",
  "total": "3",
  "ArticleList": [
    {
      "title": "IEKView：南台灣產業轉型 半導體AI賦能",
      "author": "林昭憲",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_more.aspx?indu_idno=1&domain=2&rpt_idno=565086290",
      "image": `${require('assets/images/home/news-1.jpg')}`,
      "time": "2025/04/02"
    },
    {
      "title": "Al算力競賽的真實與虛幻：從半導體到量子科技，臺灣產業的下一步",
      "author": "蘇孟宗",
      "url": "https://ieknet.iek.org.tw/iekppt/ppt_more.aspx?actiontype=ppt&indu_idno=1&domain=20&sld_preid=8030",
      "image": `${require('assets/images/home/news-2.jpg')}`,
      "time": "2025/05/22"
    },
    {
      "title": "當AI成為你的同事：從上班族到AI協作者的轉變",
      "author": "IEK產業情報網",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_more.aspx?indu_idno=1&domain=2&rpt_idno=917239052",
      "image": `${require('assets/images/home/news-3.jpg')}`,
      "time": "2025/06/03"
    },
  ]
}

export default latestArticle;